import React from "react"
import IconV2 from "../icon-v2"

import {
  StyledAttribute,
  StyledIcon,
  StyledTitle,
} from "./partials/StyledAttr"

export interface AttributeProps {
  icon: string
  title: string
}

export const AttributeCmp: React.FC<AttributeProps> = ({
  icon,
  title,
}) => (
    <StyledAttribute>
      <StyledIcon><IconV2 icon={icon} /></StyledIcon>
      <StyledTitle>{title && title}</StyledTitle>
    </StyledAttribute>
)